<template>
  <div class="container mt-3">
    <div v-for="(resultado, index) in resultados"
         :key="`resultado_registro_anterior_${index}_${ _uid }`"
         class="row RegistrosAnterioresResultados mt-2">
      <div class="col">
        <div class="row RegistrosAnterioresResultados--header RegistrosAnterioresResultados--header--click"
             @click="selecionarRegistro(resultado)">
          <div class="col">
            <div class="row no-gutters">
              <div v-if="propRadio"
                   class="d-flex align-items-center justify-content-center">
                <span class="custom-control custom-radio mr-2">
                  <input :id="`selecionarRegistro_${ index }`"
                         :checked="registroAnterior.matricula == resultado.matricula"
                         class="custom-control-input"
                         name="registroAnteriorItem"
                         :value="resultado"
                         type="radio"
                         @keyup.enter="selecionarRegistro(resultado)">
                  <label class="custom-control-label"
                         :for="`selecionarRegistro_${ index }`" />
                </span>
              </div>

              <div class="col-2 d-flex align-items-center justify-content-center"
                   :class="{'col-3': resultado.tipo_registro === 'TC'}">
                <icon-svg v-if="propTipoRegistro.match('C') || resultado.tipo_registro.match('C')"
                          icon="engagement"
                          class="icon--sm" />
                <icon-svg v-if="propTipoRegistro.match('N') || resultado.tipo_registro.match('N')"
                          icon="nascimento"
                          class="icon--sm" />
                <h5 class="ml-2 RegistrosAnterioresResultados--tipo">
                  {{ !!propTipoRegistro && tiposRegistros[propTipoRegistro] | firstCapitalize }}
                  {{ (resultado.tipo_registro && !propTipoRegistro) && tiposRegistros[resultado.tipo_registro] | firstCapitalize }}
                </h5>
              </div>

              <div class="col-4 col-sm">
                <table class="RegistrosAnterioresResultados--table">
                  <tr>
                    <th>Livro</th>
                    <th>Folha</th>
                    <th>Termo</th>
                    <th>Ocorrido</th>
                    <th>Registrado</th>
                  </tr>
                  <tr>
                    <td>{{ resultado.livro }}</td>
                    <td>{{ resultado.folha }}</td>
                    <td>{{ resultado.termo }}</td>
                    <td>{{ (resultado.data_ocorrido || '') | date }}</td>
                    <td>{{ (resultado.data_registro || '') | date }}</td>
                  </tr>
                </table>
              </div>

              <div v-if="!!resultado.uf || !!resultado.nome_cartorio"
                   class="col d-flex align-items-center">
                <icon-svg icon="mapMarker"
                          class="icon--sm"
                          style="width: 50px;" />
                <table class="RegistrosAnterioresResultados--cartorio">
                  <tr>
                    <th />
                  </tr>
                  <tr>
                    <td>
                      <b>{{ resultado.uf }}</b> {{ resultado.nome_cartorio && '- ' + resultado.nome_cartorio || '' }}
                    </td>
                  </tr>
                </table>
              </div>
              <div v-if="propRadio == false && (!!propTipoRegistro && propTipoRegistro == 'C') || (!propTipoRegistro && resultado.tipo_registro.match('C')) && !propJustShow"
                   class="col-2 d-flex align-items-center justify-content-center">
                <label class="mt-1 pt-1">
                  <div class="custom-control custom-switch">
                    <input :id="`casamentoAtual_${ _uid }_${ index }`"
                           v-model="resultado.registro_atual"
                           class="custom-control-input"
                           value="1"
                           unchecked-value="0"
                           :name="`casamentoAtual_${ _uid }`"
                           type="checkbox"
                           @change="changeCasamentoAtual(index)">
                    <label class="custom-control-label"
                           :for="`casamentoAtual_${ _uid }_${ index }`">
                      <small>
                        Último casamento
                      </small>
                    </label>
                  </div>
                </label>
              </div>
              <div v-if="propRadio == false && (!!propTipoRegistro && propTipoRegistro == 'C') || (!propTipoRegistro && resultado.tipo_registro.match('C')) && !propJustShow"
                   class="col-0 d-flex align-items-center justify-content-center">
                <div class="tooltipHelp"
                     data-tooltip="Essa opção diz respeito ao último casamento do cidadão. Para os atos de &quot;Homologação de casamento&quot; e &quot;Casamento&quot; a flag indicará o casamento anterior ao que está sendo lavrado no momento. Para o ato &quot;Óbito&quot; a opção é utilizada para indicar o último casamento do cidadão que estamos lavrando o registro, podendo indicar um casamento em vigor ou não.">
                  <icon-svg icon="helpCircle"
                            class="icon--sm iconBlue" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!resultado.sem_documentos">
          <div v-if="(!!propTipoRegistro && propTipoRegistro == 'C') || (!propTipoRegistro && resultado.tipo_registro.match('C'))"
               class="row">
            <div class="col py-2">
              <div class="row align-items-center">
                <div class="col">
                  <label>
                    <div class="row"
                         style="width: 230px">
                      <div :class="{ 'col-8': !propRadio, 'col': propRadio }">
                        <u>
                          Conjuge 1
                        </u>
                      </div>
                    </div>
                    <div>
                      <b>
                        <span v-if="propRegistro.registro && propRegistro.registro.tipo_registro == 'O'">
                          <small v-if="registroAnterior.registrado == 'nome_registrado' && propRadio && (registroAnterior.matricula === resultado.matricula)">(Falecido)</small>
                        </span>
                        {{ resultado.nome_registrado }}
                      </b>
                    </div>
                  </label>
                  <label v-if="propRadio && (registroAnterior.matricula === resultado.matricula)">
                    <div class="row"
                         style="width: 230px; margin-top: -5px;">
                      <div :class="{ 'col-8': !propRadio, 'col': propRadio }">
                        <u>
                          Novo nome
                        </u>
                      </div>
                    </div>
                    <div>
                      <b>
                        {{ resultado.nome_registrado_novo || 'Sem informação' }}
                      </b>
                    </div>
                  </label>
                </div>
                <div class="col">
                  <label>
                    <div class="row"
                         style="width: 230px">
                      <div :class="{ 'col-8': !propRadio, 'col': propRadio }">
                        <u>
                          Conjuge 2
                        </u>
                      </div>
                    </div>
                    <div>
                      <b>
                        <span v-if="propRegistro.registro && propRegistro.registro.tipo_registro == 'O'">
                          <small v-if="registroAnterior.registrado == 'conjuge' && propRadio && (registroAnterior.matricula === resultado.matricula)">(Falecido)</small>
                        </span>
                        {{ resultado.conjuge }}
                      </b>
                    </div>
                  </label>
                  <label v-if="propRadio && (registroAnterior.matricula === resultado.matricula)">
                    <div class="row"
                         style="width: 230px; margin-top: -5px;">
                      <div :class="{ 'col-8': !propRadio, 'col': propRadio }">
                        <u>
                          Novo nome
                        </u>
                      </div>
                    </div>
                    <div>
                      <b>
                        {{ resultado.conjuge_novo || 'Sem informação' }}
                      </b>
                    </div>
                  </label>
                </div>
                <div v-if="!propJustShow"
                     :class="{ 'col-4': propRadio, 'col-2': !propRadio }">
                  <b-button v-if="propRadio"
                            size="sm"
                            class="mr-2"
                            @click="editarOuAcrescentar(registroAnterior.matricula == resultado.matricula ? registroAnterior: resultado, index)">
                    {{ !propRadio ? 'Editar': 'Acrescentar informações' }}
                  </b-button>
                  <b-button v-if="!propRadio"
                            size="sm"
                            class="mr-2"
                            @click="editarOuAcrescentar(resultado, index)">
                    Editar
                  </b-button>
                  <b-button v-if="propRadio == false"
                            size="sm"
                            variant="danger"
                            @click="$emit('onDeleteRegistroAnterior', index)">
                    Excluir
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(!!propTipoRegistro && propTipoRegistro != 'C') || (!propTipoRegistro && !resultado.tipo_registro.match('C'))"
               class="row">
            <div class="col py-2">
              <div class="row">
                <div class="col">
                  <label>
                    <div><u>Registrado</u></div>
                    <div><b>{{ resultado.nome_registrado }}</b></div>
                  </label>
                </div>
                <div class="col">
                  <label>
                    <div><u>Genitor(es)</u></div>
                    <div v-if="resultado.genitor_um || resultado.genitor_dois">
                      <small v-if="resultado.genitor_um">
                        1) {{ resultado.genitor_um }}
                      </small><br>
                      <small v-if="resultado.genitor_dois">
                        2) {{ resultado.genitor_dois }}
                      </small>
                    </div>
                    <div v-else>
                      <small>Genitores não informado</small>
                    </div>
                  </label>
                </div>
                <div v-if="!propJustShow"
                     class="col-2 align-self-center"
                     :class="{ 'col-4': propRadio, 'col-2': !propRadio }">
                  <b-button size="sm"
                            class="mr-2"
                            @click="$emit('onEdit', resultado, index, true)">
                    {{ !propRadio ? 'Editar': 'Acrescentar informações' }}
                  </b-button>

                  <b-button v-if="propRadio == false"
                            size="sm"
                            variant="danger"
                            @click="$emit('onDeleteRegistroAnterior', index)">
                    Excluir
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col p-3">
              <b>O declarante não trouxe o documento e não foi encontrada na base de dados</b>
            </div>
            <div v-if="!propJustShow"
                 class="col-1 mr-3 align-self-center justify-self-end">
              <b-button v-if="propRadio == false"
                        size="sm"
                        variant="danger"
                        @click="$emit('onDeleteRegistroAnterior', index)">
                Excluir
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="propShowDissolucao && !!resultado.registro_atual"
             class="Dissolucao_casamento">
          <div class="Dissolucao_casamento_header"
               @click="showDissolucao(resultado)">
            <h1 class="Dissolucao_casamento_title">
              Informações da Dissolução
            </h1>
            <icon-svg icon="arrowDown"
                      class="icon--sm Dissolucao_casamento_icon"
                      :class="{'icon-up': resultado.showDissolucao}" />
          </div>
          <div v-if="resultado.showDissolucao">
            <div class="row justify-content-end">
              <button class="btn btn-sm btn-secondary mx-3"
                      @click="gerarTextoDissolucao(resultado, index)">
                Gerar Texto de Observação
              </button>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="descricao_dissolucao"
                         class="label">
                    Descrição
                  </label>
                  <textarea id="descricao_dissolucao"
                            v-model="resultado.informacao_dissolucao"
                            name="descricao_dissolucao"
                            cols="30"
                            rows="5"
                            class="form-control form-control-sm"
                            @change="changed()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="propJustShow"
           class="col-12 status-comunicacao pt-2">
        <div class="col-12 d-inline-flex align-items-center justify-content-between m-0 p-0">
          <div class="d-inline-flex align-items-center">
            <icon-svg icon="send"
                      class="icon--sm" />
            <h1 class="ml-2 label-comunicacao">
              Comunicação
            </h1>
          </div>
          <button v-if="!resultado.comunicacao_crc_status_local"
                  class="btn btn-sm btn-primary"
                  @click="enviarComunicacao(resultado)">
            {{ resultado.comunicacao_crc_data ? 'Reenviar comunicação' : 'Enviar comunicação' }}
          </button>
        </div>
        <hr class="hr-comunicacao">
        <div class="col-12 d-inline-flex m-0 p-0">
          <p class="m-0 p-0 mb-3 mt-1 label-comunicacao">
            <b>Status atual: </b> {{ status[resultado.comunicacao_crc_status_local] }}
          </p>
          <p v-if="resultado.comunicacao_crc_data"
             class="m-0 p-0 mb-3 mt-1 ml-5 label-comunicacao">
            <b>Data de envio: </b> {{ resultado.comunicacao_crc_data | date }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import moment from 'moment'
  import ComunicacaoService from "@/services/ComunicacaoService"

  export default {
    name: "RegistrosAnterioresResultados",
    props: {
      propRadio: {
        type: Boolean,
        default: () => true
      },
      propResultados: {
        type: Array,
        default: () => ([])
      },
      propTipoRegistro: {
        type: String,
        default: () => ""
      },
      propVinculado: {
        type: Boolean,
        default: () => false
      },
      propJustShow: {
        type: Boolean,
        default: () => false
      },
      propDisableEdit: {
        type: Boolean,
        default: () => false
      },
      propRegistro: {
        type: Object,
        default: () => ({})
      },
      propPessoa: { type: Object, default: () => ({})},
      propShowDissolucao: { type: Boolean, default: false }
    },
    data () {
      return {
        resultados: [],
        registroAnterior: {},
        casamentoAtual: {},
        tiposRegistros: {
          N: 'nascimento',
          O: 'obito',
          C: 'casamento',
          TC: 'transcrição de casamento'
        },
        status: {
          0: 'A enviar',
          1: 'Enviado'
        }
      }
    },
    watch: {
      propResultados () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.resultados = [...this.propResultados]
        this.resultados.forEach(resultado =>{
          resultado.informacao_dissolucao = resultado.informacao_dissolucao || null
          resultado.showDissolucao = !!resultado.informacao_dissolucao
        })
      },
      selecionarRegistro (registro) {
        ['C', 'TC'].indexOf(this.propTipoRegistro) != -1 && this.verificarNome(registro)

        this.emitir(registro)
      },
      registradoSelecionado (registro) {
        this.emitir(registro)
      },
      emitir (registro) {
        this.registroAnterior = { ...registro }

        if (['D', 'C', 'CR', 'TC'].indexOf(this.registroAnterior.tipo_registro) != -1) {
          const nomeRegistradoSplit = this.propRegistro.nome ? this.propRegistro.nome.split(' ') : null
          const nomeConjugeSplit = this.registroAnterior.conjuge.split(' ')
          const registradoAnterior = this.registroAnterior.nome_registrado
          const registradoAnteriorNovo = this.registroAnterior.nome_registrado_novo

          if (!!nomeRegistradoSplit && nomeRegistradoSplit[0] === nomeConjugeSplit[0]) {
            this.registroAnterior.nome_registrado = this.registroAnterior.conjuge 
            this.registroAnterior.nome_registrado_novo = this.registroAnterior.conjuge_novo

            this.registroAnterior.conjuge = registradoAnterior 
            this.registroAnterior.conjuge_novo = registradoAnteriorNovo 

            this.verificarNome(this.registroAnterior)
          }
        }

        if (this.registroAnterior) {
          // tratamos a inversão de nomes
          this.$emit('onSelectedRegistro', this.registroAnterior)
        } else {
          if (['C', 'TC'].indexOf(this.propTipoRegistro) == -1) {
            this.$emit('onSelectedRegistro', registro)
          } else {
            this.$emit('onSelectedRegistro', null)
          }
        }
      },
      verificarNome (registro) {
        const tipoRegistro = this.propRegistro.registro.tipo_registro || 'C'
        let nome = []

        if (tipoRegistro == "O") {
          nome = [this.primeiroNome(this.propRegistro.pessoa.nome || this.propRegistro.nome)]
        } else if (['D', 'C', 'CR', 'TC'].indexOf(tipoRegistro) != -1) {
          // caso não tenha o nome tentamos pegar do nome antigo
          const pessoas = this.propRegistro.registro.pessoas || this.propRegistro.pessoas
          const nome1 = pessoas[0].nome_antigo || pessoas[0].nome
          nome1 && nome.push(this.primeiroNome(nome1))

          // caso não tenha o nome tentamos pegar do nome antigo
          const nome2 = pessoas[1].nome_antigo || pessoas[1].nome
          nome2 && nome.push(this.primeiroNome(nome2))
        } else {
          return
        }


        if (nome.indexOf(this.primeiroNome(registro.nome_registrado)) != -1) {
          registro.registrado = "nome_registrado"
        } else if (nome.indexOf(this.primeiroNome(registro.conjuge)) != -1) {
          registro.registrado = "conjuge"
        } else {
          registro.registrado = null
        }
      },
      changeCasamentoAtual (indice) {
        setTimeout(() => {
          this.resultados.map((resultado, index) => {
            if (index != indice) {
              resultado.registro_atual = 0
              resultado.informacao_dissolucao = null
            } else if (index === indice && !resultado.registro_atual) {
              resultado.informacao_dissolucao = null
              resultado.showDissolucao = false
            } else if (index === indice && resultado.registro_atual) {
              resultado.showDissolucao = true
            }
          })

          this.changed()
        }, 200)
      },
      primeiroNome (nome) {
        return removerAcentos(nome.split(' ')[0])
      },
      editarOuAcrescentar (registro, index) {
        this.selecionarRegistro({ ...registro, ...{ busca: this.propRadio } })
        this.$emit('onEdit', { ...registro, ...{ busca: this.propRadio } }, index, true)
      },
      showDissolucao (registro) {
        registro.registro_atual = false
        registro.registro_atual = true

        registro.showDissolucao = !registro.showDissolucao
      },
      gerarTextoDissolucao (registro) {
        switch (this.propPessoa.estado_civil) {
        case 'DIVORCIADA':
        case 'DIVORCIADO':
          registro.informacao_dissolucao = `e que o mesmo foi dissolvido pelo divórcio aos ${registro.data_dissolucao_casamento ? moment(registro.data_dissolucao_casamento).format('DD/MM/YYYY') : '(data não informada)'}`
          registro.informacao_dissolucao += `, conforme certidão de casamento lavrada no Livro ${registro.livro}, fls ${registro.folha}, sob o número ${registro.termo}.`
          break
        case 'VIUVA':
        case 'VIUVO':
          registro.informacao_dissolucao = `tendo sido o mesmo dissolvido por falecimento do cônjuge aos ${registro.data_dissolucao_casamento ? moment(registro.data_dissolucao_casamento).format('DD/MM/YYYY') : '(data não informada)'}.`
          break
        default:
          registro.informacao_dissolucao = "tendo sido o mesmo dissolvido por"
          break
        }

        this.changed()
      },
      changed () {
        this.$emit('changed')
      },
      async enviarComunicacao (registroAnterior) {
        try {
          loader({active: true, text: ""})

          const res = await ComunicacaoService.enviarComunicacoes({
            registros_anteriores: [
              { registro_anterior_id: registroAnterior.registro_anterior_id }
            ]
          })

          if (res.errors && res.errors.length) {
            const erro = res.errors[0].error || res.errors[0]

            throw erro
          } else {
            await displayMessage('success', 'Comunicação enviada com sucesso!')
          }

        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ""})
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../scss/_utilities/_exports';

  .iconBlue {
    height: 3rem;
  }

  .tooltipHelp::before,
  .tooltipHelp::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(-95%) translateY(95%) scale(var(--scale));
  }

  .tooltipHelp::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 65%;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipHelp:hover::before,
  .tooltipHelp:hover::after {
    --scale: 1;
  }

  .tooltipHelp:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-110%) translateY(-30%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }

  .RegistrosAnterioresResultados {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &--header {
      background-color: $sofiaRei-blue;
      min-height: 30px;
      display: flex;
      align-content: center;

      &--click{
        cursor: pointer;
      }
    }

    &--cartorio {
      font-size: 14px;
    }

    &--tipo {
      font-size: 1rem;
    }

    &--table {
      font-size: 12px;
      & tr:first-child {
        border-bottom: 1px solid black;
      }

      & th, td {
        padding-left: 6px;
        padding-right: 6px;
      }
    }
  }

  .label-comunicacao {
    font-size: 15px;
  }

  .hr-comunicacao {
    padding: 0px;
    margin: 0px;
    background: #000;
  }

  .status-comunicacao {
    background: #eaeaea;
  }

  .Dissolucao_casamento {
    &_header {
      cursor: pointer;
      border-top: 1px solid #000000;
      border-bottom: 1px solid #000000;
      margin-bottom: 10px;
      display: inline-flex;
      align-items: center;
      width: 100%;
    }

    &_title {
      font-size: 20px;
      margin-right: 10px;
    }

    &_icon {
      transition: 0.2s;
      width: 10px;
    }
  }

  .icon-up {
    transition: 0.2s;
    transform: rotate(-180deg);
  }
</style>
